import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';

import onHoverPopup from 'webapp/modifiers/on-hover-popup';
import MetricLibraryPopupsPopupMetricBasicInfoComponent from 'webapp/components/metric-library/popups/popup-metric-basic-info';

import type { Metric, MetricFromClient } from 'webapp/models-custom';

interface Args {
	model: Metric | MetricFromClient;
	theme?: string;
	suppress?: boolean;
	mouseLeaveDelay?: number;
}

interface MetricLibraryPopupsMetricBasicInfoTooltipComponentInterface<T> {
	Args: T;
	Blocks: {
		default: [];
	};
}

export default class MetricLibraryPopupsMetricBasicInfoTooltipComponent extends Component<
	MetricLibraryPopupsMetricBasicInfoTooltipComponentInterface<Args>
> {
	@service('popup') declare popupService: Service.Popup;

	@tracked isPopupOpen = false;
	mouseLeaveDelay;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.mouseLeaveDelay = this.args.mouseLeaveDelay || 0;
	}

	@action
	openMetricBasicInfoPopup(el: HTMLElement) {
		const popupCM = this.metricBasicInfoPopup(el);

		return popupCM;
	}

	async metricBasicInfoPopup(el: HTMLElement) {
		// if (this.args.suppress) {
		// 	return Promise.reject();
		// }

		const component = MetricLibraryPopupsPopupMetricBasicInfoComponent;

		if (this.popupService.isOpen(component)) {
			const existingPopupExactlyHere = this.popupService.findContextByComponentAndAttachTo(
				component,
				el,
			);
			if (existingPopupExactlyHere) {
				// this one's already open, do nothing
				return existingPopupExactlyHere;
			}

			const existingPopup = this.popupService.findByComponent(component);
			if (existingPopup) {
				await existingPopup?.close();
			}
		}

		const popup = this.popupService.createContext(component, el, {
			popupClass: 'popup-type-metric-basic-info',
			theme: this.args.theme,
		});

		const popupCM = popup.open({
			model: this.args.model,
		});

		this.isPopupOpen = true;

		popup.on(PopupEvent.CLOSING, this, () => {
			this.isPopupOpen = false;
		});

		return popupCM || null;
	}
	<template>
		<div class="metric-basic-info-tooltip">
			{{! inner container added because on-hover-popup registers hover over el margin, so having another ct allows for easier styling and positioning }}
			<div
				class="metric-basic-info-tooltip-ct"
				{{onHoverPopup this.openMetricBasicInfoPopup this.mouseLeaveDelay}}
			>
				{{yield}}
			</div>
		</div>
	</template>
}
